import './admission-access-gate.css';

/**
 * 公开表单门禁（pass-through）：咨询 / 意向表单对任何访客开放，无需登录。
 * 组件保留以维持路由结构不变；不再做私有门禁校验。
 */
export default function AdmissionAccessGate({ children }) {
  return children;
}
